import { compose, path, propOr } from 'ramda';

import { splitPath } from 'utils';

import { NAME } from './constants';

const emptyObject = {};

const getByProp = (customProp, state) => compose(path(splitPath(customProp)), getDetail)(state);

export const getDetail = (state) => state[NAME];

export const getTaskId = (state) => getByProp('id', state);

export const getTypeId = (state) => getByProp('taskTypeId', state);

export const getStatusId = (state) => getByProp('statusId', state);

export const getSolverIsLoggedUser = (state) => getByProp('solverIsLoggedUser', state);

export const getFinishTypeId = (state) => getByProp('finishTypeId', state);

export const getLoggedUserQueueMember = (state) => getByProp('loggedUserQueueMember', state);

export const getSubtypeId = (state) => getByProp('taskSubtypeId', state);

export const getSourceSystemId = (state) => getByProp('taskSourceSystemId', state);

export const getAttachments = (state) => getByProp('taskAttachments', state);

export const getMetadata = (state) => getByProp('metadata', state);

export const getTaskComments = (state) => getByProp('comments', state);

export const getPolicyNo = (state) => getByProp('policy.policyNo', state);

export const getClientCcdId = (state) => getByProp('client.id', state);

export const getHistory = (state) => getByProp('history', state);

export const getReadStatus = (state) => getByProp('read', state);

export const policyHolder = (state) => compose(propOr(emptyObject, 'policyHolder'), getPolicy)(state);

export const getClient = (state) => compose(propOr(emptyObject, 'client'), getDetail)(state);

export const getPolicy = (state) => compose(propOr(emptyObject, 'policy'), getDetail)(state);

export const getMetaDataCommon = (state) => compose(propOr(emptyObject, 'common'), getMetadata)(state);

export const getInsuredPersons = (state) => compose(propOr(emptyObject, 'insuredPersons'), getMetadata)(state);
